export const dogTrain = [
    "endurance", "speed", "agility",
]